import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TournamentRatingPlayers from "./TournamentRatingPlayers";
import { openTournamentRating } from "../../../utils/tournamentRatingBus";
import useAxios from "../../../utils/useAxios";

const TournamentRating = ({ tournament, is_authorized, viewMode, searchChips }) => {
    const { id } = useParams();
    const api = useAxios();
    const [settings, setSettings] = useState(null);
    // Bumped every time the rating-settings effect below re-fetches (i.e.
    // whenever `tournament` itself is refreshed) - was previously a dead
    // useState(0) with no setter, so TournamentRatingPlayers' own fetch
    // effect (which lists this among its deps) never re-ran after a rating
    // settings save/reset.
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        if (!id || !tournament?.rating) return;
        api.get(`/api/v1.0/tournaments/${id}/rating-settings/`)
            .then(res => {
                setSettings(res.data);
                setRefreshTrigger(n => n + 1);
            })
            .catch(e => console.error("Failed to fetch settings", e));
        // `tournament` (not just tournament?.rating) so this also re-runs
        // on a rating_mode-only settings change, not just when the rating
        // base itself changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, tournament]);

    // Results (place/matches/wins/losses) stand on their own regardless of
    // whether a rating base is linked - only the Points column (ratingMode-
    // gated inside TournamentRatingPlayers/renderScore) and this tab's own
    // settings fetch above actually need tournament.rating.
    return (
        <TournamentRatingPlayers
            tournamentGrade={tournament?.grade || ""}
            refreshTrigger={refreshTrigger}
            ratingMode={settings?.rating_mode}
            teamSize={tournament?.team_size || null}
            is_authorized={is_authorized}
            onOpenRatingTable={openTournamentRating}
            viewMode={viewMode}
            hasRatingBase={!!tournament?.rating}
            tournament={tournament}
            searchChips={searchChips}
        />
    );
};
export default TournamentRating;
